// pages/us/blog/[url_slug].jsx   // MERGED: serves BOTH posts and tag listings at /us/blog/:url_slug
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import { Helmet } from "react-helmet";
import LatestNews from "../../../components/LatestNews";
import { Container } from "reactstrap";
import NewBlogDetails from "../../../components/NewBlogDetails";
import NewSubBanner from "../../../components/NewSubBanner";
import NewColumnWithForm from "../../../components/NewColumnWithForm";
import NewBlogDetails2 from "../../../components/NewBlogDetails2";
import MainBanner from "../../../components/MainBanner";
import AllBlogs from "../../../components/AllBlogs";
import NewFeaturedBlogs from "../../../components/NewFeaturedBlogs";

function hasTag(item, tagName) {
  if (!item?.tag || !tagName) return false;
  const target = String(tagName).toLowerCase();
  const t = item.tag;
  if (Array.isArray(t)) return t.some((x) => String(x).toLowerCase() === target);
  if (Array.isArray(t?.en)) return t.en.some((x) => String(x).toLowerCase() === target);
  if (typeof t?.en === "string") return String(t.en).toLowerCase() === target;
  if (typeof t === "string") return t.toLowerCase() === target;
  return false;

}
// ---------- POST VIEW ----------
function USPostView({ global, page, all_news, related_news }) {
  const breadcrumbList = [
    { "@type": "ListItem", name: "SRG", position: 1, item: { "@type": "Thing", "@id": `https://www.srgtalent.com/us` } },
    { "@type": "ListItem", position: 2, name: "Blog", item: { "@type": "Thing", "@id": `https://www.srgtalent.com/us/blog` } },
  ];

  return (
    <>
      <SeoHead
        page_name={`${page.title} | SRG${page.tag.includes("News & Insights") ? " Insights" : "" }`}
        description={page.tag.includes("Case Study") ? `Discover insights from "${page.title}" and how SRG delivers effective solutions across Life Sciences in the US.` : `Expert insights on ${page.title} from SRG, specialists in Life Sciences in the US.`}
        canonical_link={`blog/${page.url_slug}`}
        og_image={page.image}
        og_img_alt={`${page.title}`}
        en_gb={false}
        en_us={true}
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({ "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: breadcrumbList })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            description: page?.short_description || "",
            isFamilyFriendly: "http://schema.org/True",
            image: page?.image || "",
            dateModified: page?.updated_at || "",
            datePublished: page?.created_at || "",
            name: page?.title || "",
            headline: page?.title || "",
            articleBody: page?.content ? page.content.replace(/<[^>]*>/g, "") : "",
            publisher: {
              "@type": "Organization",
              name: "SRG",
              sameAs: "https://www.srgtalent.com/us",
              logo: { "@type": "ImageObject", url: "https://cdn.sourceflow.co.uk/otncy6ttisad8f91af1vjs6kh25s" },
            },
            author: { "@type": "Person", image: page?.author_image || "", name: page?.author || "" },
          })}
        </script>
      </Helmet>

      <NewSubBanner
        global={global}
        pathPrefix={`us.${page.url_slug}.insights_page.main_banner`}
        customClass={``}
        content={<h1>{page.title}</h1>}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/svg/banner-overlay.svg`}
        imageALT2={`Overlay Main Banner`}
        displayImage1={false}
        editableContent={false}
        buttonLink={`${
          page.tag.includes("Case Study")
            ? "/us/blog/case-study"
            : page.tag.includes("Guides & Reports")
            ? "/us/blog/guides-and-reports"
            : "/us/blog"
        }`}
        buttonTitle={`${
          page.tag.includes("Case Study")
            ? "Back to Case Study"
            : page.tag.includes("Guides & Reports")
            ? "Back to Guides & Reports"
            : "Back to insights"
        }`}
        post={page}
        buttonLink2={`${page.tag.includes("Guides & Reports") && page.form_id ? "#download-form" : ""}`}
        buttonTitle2={`${page.tag.includes("Guides & Reports") && page.form_id ? "Download Report" : ""}`}
      />

      {page.tag.includes("Guides & Reports") || page.tag.includes("News & Insights") ? (
        <NewBlogDetails
          global={global}
          pathPrefix={`us.insights_page.guides_and_reports.new_blog_details`}
          page={page}
          related_news={related_news}
          page_prefix={`blog`}
          share_heading={`Share Report`}
          className={`py-5 guides-and-reports-page`}
          formId={`${page?.form ? page.form : "4217ca23-d775-49d4-8a0e-80e2220e8369"}`}
          locale={``}
          successPageUrl={
            page.form_link ? page.form_link : page.form_attachment ? page.form_attachment : "/submission-success"
          }
        />
      ) : page.tag.includes("Case Study") ? (
        page.case_study_tabs?.length >= 1 ? (
          <NewBlogDetails2 global={global} pathPrefix={`us.insights_page.new_blog_details_2`} page={page} />
        ) : (
          <NewBlogDetails
            global={global}
            pathPrefix={`us.insights_page.new_blog_details`}
            page={page}
            related_news={related_news}
            page_prefix={`blog`}
            locale={`us`}
          />
        )
      ) : (
        <NewBlogDetails
          global={global}
          pathPrefix={`us.insights_page.new_blog_details`}
          page={page}
          related_news={related_news}
          page_prefix={`blog`}
          locale={`us`}
        />
      )}

      {(page.tag.includes("Guides & Reports") || page.tag.includes("Case Study")) && all_news.length >= 1 ? (
        <>
          <Container><hr /></Container>
          <LatestNews
            global={global}
            pathPrefix={`us.${page.url_slug}.insights_page.guides_and_reports.latest_news`}
            customClass={`py-5 white-card`}
            post={
              page.tag.includes("Guides & Reports")
                ? all_news.filter((p) => hasTag(p, "Guides & Reports") && p.title !== page.title)
                : all_news.filter((p) => hasTag(p, "Case Study") && p.title !== page.title)
            }
            locale={`us`}
            content={<h2>{page.tag.includes("Guides & Reports") ? "Other Guides and Reports" : "Other Case Studies"}</h2>}
            buttonLink={``}
            buttonTitle={``}
            content_align={`left`}
            footer_buttonLink={`/us/blog${page.tag.includes("Guides & Reports") ? "/guides-and-reports" : "/case-study"}`}
            footer_buttonLink_title={`View All`}
          />
        </>
      ) : null}

      <NewColumnWithForm
        global={global}
        pathPrefix={`us.insights_page.new_column_with_form`}
        customClass={`pb-5`}
        heading={`How can we help you?`}
        formId={`e1da7ff6-feb2-4696-93be-b43ec16b6009`}
        description={<p>Contact us if you are interested in finding out more about how we can help you.</p>}
      />
    </>
  );
}

// ---------- TAG VIEW ----------
function USTagView({ global, page, all_news }) {
  return (
    <>
      <SeoHead
        page_name={`${page.title} | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
        canonical_link={`blog/${page.url_slug}`}
        en_gb={false}
        en_us={true}
      />
      <MainBanner
        global={global}
        pathPrefix={`us.insights_page.main_banner`}
        customClass={``}
        content={<h1>{page.title}</h1>}
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
        editableContent={false}
        displayImage1={false}
      />
      <NewFeaturedBlogs
        global={global}
        pathPrefix={`us.${page.url_slug}.insights_page.new_featured_blogs`}
        customClass={`py-5 grayGradientBg`}
        content={<h2>Featured {page.title}</h2>}
        post={all_news}
        socialPagePrefix={`us/blog/${page.url_slug}`}
        pagePrefix={`us/blog/`}
      />
      <AllBlogs
        global={global}
        pathPrefix={`us.news_page.all_blogs`}
        customClass={`py-5 lightGreybg`}
        post={all_news}
        ParentNews={false}
        tagName={`${page.title}`}
        heading={`All ${page.title}`}
        pagePrefix={`us/blog/`}
        cardPagePrefix={`us/blog/`}
      />
      <NewColumnWithForm
        global={global}
        pathPrefix={`us.insights_page.new_column_with_form`}
        customClass={`pb-5`}
        heading={`How can we help you?`}
        formId={`e1da7ff6-feb2-4696-93be-b43ec16b6009`}
        description={<p>Contact us if you are interested in finding out more about how we can help you.</p>}
      />
    </>
  );
}

// ---------- UNIFIED ----------
export default function USBlogUnified(props) {
  return props.mode === "post" ? <USPostView {...props} /> : <USTagView {...props} />;
}

// ---------- DATA ----------
export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  // Try POST first (US or All)
  let postPage = null;
  try {
    postPage = (await Collection("news")).getJsonItem(params.url_slug, "url_slug");
  } catch (_) {}

  if (postPage && postPage.url_slug) {
    const news = (await Collection("news"))
      .filter((post) => post.country?.en == "United States" || post.country?.en == "All")
      .filter((post) => Array.isArray(post.tag?.en) && post.tag.en.some((t) => postPage.tag?.includes(t)));

    const all_news = news.orderBy("order").getItems().slice(0, 8);
    const related_news = news.orderBy("order").getItems().slice(0, 2);

    return {
      props: { global, mode: "post", page: postPage, all_news, related_news },
    };
  }

  // Fallback to TAG — sector/topic tags and content types live in separate collections
  let tagPage = null;
  try {
    tagPage = (await Collection("news_tag")).getJsonItem(params.url_slug, "url_slug");
  } catch (_) {}

  if (!tagPage) {
    try {
      tagPage = (await Collection("news_content_type")).getJsonItem(params.url_slug, "url_slug");
    } catch (_) {}
  }

  if (!tagPage) return { notFound: true };

  const tagName = tagPage.title;
  const newsForTag = (await Collection("news"))
    .filter((post) => post.country?.en == "United States" || post.country?.en == "All")
    .filter((post) => Array.isArray(post.tag?.en) && post.tag.en.includes(tagName));

  const all_news = newsForTag
    .orderBy((n) => Date.parse(n.date?.en), "desc")
    .getItems();

  return {
    props: { global, mode: "tag", page: tagPage, all_news },
  };
}

export async function getStaticPaths() {
  // Post URLs
  const postPaths = (await Collection("news"))
    .filter((post) => post.country?.en == "United States" || post.country?.en == "All")
    .getPaths("url_slug");

  // Tag URLs — career-advice is included here, unlike the UK route, where a hand-built
  // /career-advice page owns that listing instead
  const tagPaths = (await Collection("news_tag")).getPaths("url_slug");

  // Content type URLs
  const contentTypePaths = (await Collection("news_content_type")).getPaths("url_slug");

  return {
    paths: [...postPaths, ...tagPaths, ...contentTypePaths],
    fallback: false,
  };
}
